import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import LangEnum from '../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../translation/TranslationContext';
import { useRachelMessageActionButtonStyles } from '../../../../rachelMessageItem.styles';
import RachelMessageFeedbackModal from './components/RachelMessageFeedbackModal/RachelMessageFeedbackModal';
import { useRachelMessageFeedback } from './useRachelMessageFeedback';

interface RachelMessageFeedbackProps {
  messageId: string;
}

const RachelMessageFeedback = ({ messageId }: RachelMessageFeedbackProps) => {
  const { translate } = useTranslation();
  const {
    rating,
    comment,
    problemType,
    pendingRating,
    isFeedbackEnabled,
    onLike,
    onDislike,
    isModalOpen,
    closeModal,
    submit,
  } = useRachelMessageFeedback({ messageId });
  const { classes, cx } = useRachelMessageActionButtonStyles();
  const likeLabel = translate(LangEnum.RACHEL_FEEDBACK_LIKE);
  const dislikeLabel = translate(LangEnum.RACHEL_FEEDBACK_DISLIKE);

  return (
    <>
      <Tooltip TooltipContent={likeLabel} tabIndex={-1}>
        <IconButton
          icon={ThumbsUp}
          size="small"
          disabled={!isFeedbackEnabled}
          className={cx(classes.actionButton, rating === 'like' && classes.actionButtonActive)}
          ariaLabel={likeLabel}
          ariaPressed={rating === 'like'}
          onClick={onLike}
        />
      </Tooltip>
      <Tooltip TooltipContent={dislikeLabel} tabIndex={-1}>
        <IconButton
          icon={ThumbsDown}
          size="small"
          disabled={!isFeedbackEnabled}
          className={cx(classes.actionButton, rating === 'dislike' && classes.actionButtonActive)}
          ariaLabel={dislikeLabel}
          ariaPressed={rating === 'dislike'}
          onClick={onDislike}
        />
      </Tooltip>
      <RachelMessageFeedbackModal
        isOpen={isModalOpen}
        rating={pendingRating}
        initialComment={comment}
        initialProblemType={problemType}
        onClose={closeModal}
        onSubmit={submit}
      />
    </>
  );
};

export default RachelMessageFeedback;
